import DataModel from './data_model';

class User extends DataModel {
    static _instance = null;

    constructor(props) {
        super();
        this.initializeFromJSON(props);
    }

    // Method to create a new instance
    static Instance(props) {
        if (!User._instance) {
            User._instance = new User(props);
            localStorage.setItem('user', User._instance._id);
        }
        return User._instance;
    }

    // Method to get the current instance
    static getInstance() {
        return User._instance;
    }

    // Method to reset the user (e.g., log out)
    static resetInstance() {
        localStorage.removeItem('user');
        User._instance = null;
    }
}

export default User;
